import React from 'react';

const MarkCompleteConfirmationModal = ({ onClose, projectId, handleMarkAsComplete }) => {
    return (
        <div
            className="modal d-block ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content ct_border_radius_20">
                    <div class="modal-header border-0">
                        <button
                            type="button"
                            class="btn-close ct_circle_close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pb-5 pt-0">
                        <div class="mx-auto d-block text-center ct_mb_20">
                            <svg
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                                    fill="#FFB703"
                                />
                            </svg>
                        </div>
                        <div class="text-center">
                            <h4 class="ct_fs_18 ">Mark this Project as Complete?</h4>
                            <p
                                className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                                style={{ maxWidth: "388px" }}
                            >
                                Confirm that you’ve finished this project. The client will be
                                notified for final review
                            </p>
                        </div>
                        <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                            <button
                                class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                                type="button"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                            <button
                                class="ct_yellow_btn px-5 ct_h_44"
                                onClick={() => {
                                    onClose()
                                    handleMarkAsComplete(projectId)
                                }}
                                type="button"
                            >
                                Mark as Complete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarkCompleteConfirmationModal;